export default __webpack_public_path__ + "static/media/logo.86c21415.png";